import { InputParsedNumber } from '@shared/components'
import { Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { usePropertyInsuranceValues } from './PropertyInsuranceContext'

type Props = {
  fieldKey: number
}

export const ItemCategoryDFields = ({ fieldKey }: Props) => {
  const { t } = useTranslation()
  const { isEditable } = usePropertyInsuranceValues()

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} md={12}>
        <Form.Item name={[fieldKey, 'd', 'model']} label={t('model')}>
          <Input placeholder={t('model')} disabled={isEditable} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name={[fieldKey, 'd', 'year']}
          label={t('year_of_production')}
        >
          <InputParsedNumber
            min={0}
            placeholder={t('year_of_production')}
            className="w-full"
            disabled={isEditable}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
